import React from 'react';
import { useCartActions } from '../../hooks/useAddCart.js';


export default function GiftCards() {
  const { updateCart } = useCartActions();

  const addToCart = () => {
    let product = {
      _id: 'giftcard-50',
      title: 'Asterism Books $50 Gift Card',
      authors: ['Asterism Books'],
      dimensions: {
        weight: 2,
      },
      prices: {

      },

    }
    updateCart(product._id, product, 1, false);
  }

  return (
    <div>
      <div>
        <h3>$50 Gift Card (red)</h3>
        <button className='buttonPrimary'>Add to Cart</button>
      </div>
    </div>
  )
}